/*
 *   File : fund-investment.js
 *   Author URI : https://evoqins.com
 *   Description :Selecting payment method modal
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import React, { useState, useEffect, Fragment, useRef } from "react";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useRazorpay, } from "react-razorpay";

// Assets 
import SuccessImage from "../../Assets/Images/Modal/success.png";
import FailedImage from "../../Assets/Images/Modal/failed.png";

// Components
import { Icon } from "../Icon";
import { LinkButton, PrimaryButton, SecondaryButton } from "../Buttons";
import { CustomAmountInput, CustomPINInput, RadioGroup } from "../FormElements";
import { SIPDateModal } from ".";
import { CustomTabBar } from "../Tab";
import { ConsentCard } from "../Cards";

import { CustomDropdown } from "../Dropdown";
// Custom styles
import Color from '../../Styles/color.module.scss';
import style from "../../Styles/Components/payment-type.module.scss";

// Custom services
import { _findNearestDate, _formatSip, _getTomorrowDate, _getTomorrowDay, useCountdown, WEEKLY_OPTIONS } from "../../Helper/helper";
import { _checkMandate, _generate2Fa } from "../../Helper/api";
import APIService from "../../Services/api-service";

const AMOUNT_CHIP = [{
    id: 1,
    label: "+₹10,000",
    amount: 10000
},
{
    id: 2,
    label: "+₹20,000",
    amount: 20000
},
{
    id: 3,
    label: "+₹50,000",
    amount: 50000
}]

const TAB_DATA = [
    {
        id: 1,
        label: "SIP"
    },
    {
        id: 2,
        label: "Lumpsum"
    }
];

const SIP_DATA = [
    {
        id: 1,
        label: "SIP"
    },
];

const LUMPSUM_DATA = [
    {
        id: 2,
        label: "Lumpsum"
    }
];

const FIRST_INSTALLMENT = [{
    id: 1,
    name: "Yes"
},
{
    id: 2,
    name: "No"
}];

const FundInvestModal = React.memo((props) => {
    const termsRef = useRef();
    const amountRef = useRef();

    const { Razorpay } = useRazorpay();


    const navigate = useNavigate();
    const location = useLocation();
    const PROFILE_DETAILS = useSelector(state => state.Reducer.PROFILE_DETAILS);
    const MASKED_NUMBER = PROFILE_DETAILS.phone.masked_number;
    const { seconds, resetCountdown } = useCountdown(30);

    const [paymentType, setPaymentType] = useState(props.paymentType);
    const [sipAmount, setSipAmount] = useState(props.amount);
    const [sipAmountError, setSipAmountError] = useState("");

    const [lumpsumAmount, setLumpsumAmount] = useState(props.lumpsumAmount);
    const [lumpsumAmountError, setLumpsumAmountError] = useState("");

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateString, setSelectedDateString] = useState("");
    const [toggleDateModal, setToggleDateModal] = useState(false);

    const [isFirstInstallment, setIsFirstInstallment] = useState(props.isFirstInstallment);

    const [selectedTab, setSelectedTab] = useState(props.selected);

    const [submitLoader, setSubmitLoader] = useState(false);
    const [modalLoader, setModalLoader] = useState(false);
    const [termsError, setTermsError] = useState(null);


    const [screenNumber, setScreenNumber] = useState(1);
    const [otpRequestData, setOtpRequestData] = useState(null);

    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");

    const [paymentModalData, setPaymentModalData] = useState({});

    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const [frequencyOptions, setFrequencyOptions] = useState([]);
    const [frequencySelected, setFrequencySelected] = useState(null);

    const [folioOptions, setFolioOptions] = useState([]);
    const [folio, setFolio] = useState(null);
    const [folioError, setFolioError] = useState("");

    const [daySelected, setDaySelected] = useState(_getTomorrowDay());
    const [daySelectedError, setDaySelectedError] = useState("");


    useEffect(() => {
        var my_modal = document.getElementById("fund-invest");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.closeModal();
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.frequencies && props.frequencies.length !== 0) {
            const frequencies = props.frequencies.map((item) => {
                return ({
                    name: item.label, id: item.value
                })
            })
            setFrequencyOptions(frequencies);
            const monthly_frequency = frequencies.find((item) => item.id === "monthly")
            if (monthly_frequency) {
                setFrequencySelected(monthly_frequency.id);
            } else {
                setFrequencySelected(frequencies[0].id);
            }
        }
    }, [props.frequencies]);

    useEffect(() => {
        if (props.frequencyData && frequencySelected !== null) {
            if (props.frequencyData[`${frequencySelected}`].dates !== null) {
                if (frequencySelected !== "daily") {
                    if (frequencySelected === "monthly") {
                        setSelectedDate(_findNearestDate(props.frequencyData[`${frequencySelected}`].dates, _getTomorrowDate()));
                    } else {
                        setSelectedDate(daySelected.value);
                    }
                }
                const date_string = _formatSip(_findNearestDate(props.frequencyData[`${frequencySelected}`].dates, _getTomorrowDate()));
                setSelectedDateString(date_string);
            }
        }
        // eslint-disable-next-line
    }, [props.frequencyData, frequencySelected]);

    useEffect(() => {
        const folio_options = []
        if (props.createNew) {
            folio_options.push({
                label: <div className="e-montserrat-medium" dangerouslySetInnerHTML={{ __html: `Create New Folio` }} />,
                value: null
            })
        }
        props.folioData.map((item) => {
            return (
                folio_options.push({
                    label: <div className="e-montserrat-medium" dangerouslySetInnerHTML={{ __html: `${item.folio_number} <br /> <span style="font-size:12px" class="e-montserrat-regular">Amount:</span> ₹${item.amount} ${item.units ? `<span style="font-size:12px" class="e-montserrat-regular">Units:</span> ${item.units}` : ``}` }} />,
                    value: item.folio_number

                })
            )
        });

        setFolioOptions(folio_options);
        if (props.createNew || folio_options.length === 1) {
            setFolio(folio_options[0]);
        }
        // eslint-disable-next-line
    }, [props.folioData]);

    // open sip date modal
    useEffect(() => {
        if (toggleDateModal === true) {
            const modal = new Modal(document.getElementById("sip-date"), {});
            modal.show();
        }
    }, [toggleDateModal]);

    // update sip amount and lumpsum
    useEffect(() => {
        if (props.amount) {
            setSipAmount(props.amount);
        }
        // else if (props.summary.min_investment.sip !== 0) {
        //     setSipAmount(props.summary.min_investment.sip);
        // }
        if (props.lumpsumAmount) {
            setLumpsumAmount(props.lumpsumAmount);
        }
        // else if (props.summary.min_investment.lumpsum !== 0) {
        //     setLumpsumAmount(props.summary.min_investment.lumpsum);
        // }
        // eslint-disable-next-line
    }, []);

    // handle payment type
    function _handlePayment(item) {
        setPaymentType(item);
    }

    // pay now handler
    function _handleFirstInstallment(id) {
        setIsFirstInstallment(id);
    }

    // handle sip amount
    function _handleAmount(input_value) {
        setSipAmount(input_value);
        setSipAmountError("");
    }

    // handle lumpsum amount
    function _handleLumpsum(input_value) {
        setLumpsumAmount(input_value);
        setLumpsumAmountError("");
    }

    // add amount to existing
    function _handleChipClick(item) {
        if (selectedTab === 1) {
            setSipAmount(prevAmount => (prevAmount !== "" ? prevAmount : 0) + item.amount)
            setSipAmountError("");
        }
        else {
            setLumpsumAmount(prevAmount => (prevAmount !== "" ? prevAmount : 0) + item.amount);
            setLumpsumAmountError("");
        }
    }

    // show sip date modal
    function _handleCloseModal(status) {
        setToggleDateModal(status);
    }

    // handle tab
    function _handleTabChange(value) {
        setSelectedTab(value);
        props.handleTabChange(value);
    }

    // handle sip date
    function _handleSelectDate(date, dateString) {
        setSelectedDate(date);
        setSelectedDateString(dateString)
    }

    // 1st screen submit handler
    function _handleInvest() {
        let valid = true;
        if (selectedTab === 1) {
            if (props.summary.mandate_status === false) {
                _createMandate();
            } else {
                if (props.summary.min_investment.sip !== 0) {
                    if (sipAmount === "") {
                        setSipAmountError(`Enter ${_getFrequencyLabel(frequencySelected)} SIP amount`);
                        amountRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
                        valid = false;
                        return;
                    }
                    if (folio === null && folioOptions.length > 0) {
                        valid = false;
                        setFolioError("Please select folio");
                        amountRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
                        return;
                    }

                    if (daySelected === null && (frequencySelected === "day_in_a_week" || frequencySelected === "day_in_a_fortnight")) {
                        valid = false;
                        setDaySelectedError("Please select day for SIP");
                        return;
                    }
                    if (acceptedTerms === false) {
                        valid = false;
                        toast.dismiss();
                        setTermsError(true);
                        termsRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
                        toast.error("Accept consent", {
                            type: "error",
                        });
                    }
                    if (valid) {
                        _confirmInvest();
                    }
                }
            }
        }
        else {

            if (props.summary.min_investment.lumpsum !== 0) {
                if (lumpsumAmount === "") {
                    setLumpsumAmountError("Enter lumpsum amount you wish to invest");
                    amountRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    valid = false;
                    return;
                }
            }
            if (folio === null && folioOptions.length > 0) {
                valid = false;
                setFolioError("Please select folio");
                amountRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
                return;
            }
            if (acceptedTerms === false) {
                valid = false;
                toast.dismiss();
                setTermsError(true);
                termsRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
                toast.error("Accept consent", {
                    type: "error",
                });
            }
            if (valid) {
                _confirmInvest();
            }
        }
    }

    // handle OTP
    function _handleOTP(input_value) {
        if (input_value.length <= 4) {
            setOtp(input_value);
        }
        setOtpError("");
    }

    // resend OTP
    function _handleResend() {
        setOtp("");
        setOtpError("");
        _generate2FaApi();
    }

    function _handleFrequency(select_value) {
        setFrequencySelected(select_value);
    }

    function _handleWeeklyDate(dropdown_value) {
        setDaySelected(dropdown_value);
        setSelectedDate(dropdown_value.value);
        setDaySelectedError("");
    }

    // handle folio number
    function _handleFolio(select_value) {
        setFolio(select_value);
        setFolioError("");
    }
    // handle submit otp validation
    async function _submitOTP() {
        let valid = true;
        if (otp === "") {
            setOtpError("OTP is required");
            valid = false;
        }
        if (otp !== "" && otp.length !== 4) {
            setOtpError("Invalid OTP");
            valid = false;
        }
        if (valid) {
            try {
                const result = await _mfInvest();
                if (result) {
                    setScreenNumber(3);
                }
            } catch (error) {
                console.error("Error verifying OTP:", error);
            }
        }
    }

    const _getFrequencyLabel = (frequency) => {
        if (frequency !== null) {
            const index = frequencyOptions.findIndex((item) => item.id === frequency)
            return (frequencyOptions[index].name)
        }
    }

    // investment_type
    // 1 goal
    // 2 fund
    // 3 basket

    // status screen secondary button handler
    const _handleScreen3SecondaryButton = () => {
        if (selectedTab === 1 && isFirstInstallment === 2) {
            navigate("/systematic-transactions", {
                state: {
                    filter: 2,
                    filter_label: "Individual funds",
                    tab_index: 1,

                }
            })
        }
        else {
            if (paymentModalData.type === 0) {
                navigate("/orders", {
                    state: {
                        id: paymentModalData.order_id,
                        paymentTypes: [],
                        orderStatus: [],
                        orderTypes: [],
                        startDate: "DD-MM-YYYY",
                        endDate: "DD-MM-YYYY",
                        type: 2,
                        page: 1
                    }
                })
            } else {
                navigate("/orders", {
                    state: {
                        id: paymentModalData.order_id,
                        paymentTypes: [],
                        orderStatus: [],
                        orderTypes: [],
                        startDate: "DD-MM-YYYY",
                        endDate: "DD-MM-YYYY",
                        type: 2,
                        page: 1
                    }
                })
            }
        }
    }

    // status screen primary button handler
    const _handleScreen3PrimaryButton = () => {
        props.invested()
        if (paymentModalData.type === 1) {
            navigate("/portfolio")
        }
        else {
            document.getElementById("close-modal").dispatchEvent(new Event("click"));

        }

    }

    const _otpLabel = () => {
        if (selectedTab === 1) {
            return isFirstInstallment === 2 ? "Verify & Schedule" : "Verify & Invest";
        }
        return "Verify & Invest";
    };

    const _investLabel = () => {
        if (selectedTab === 1) {
            return props.summary.mandate_status === true ?
                isFirstInstallment === 2 ? "Schedule SIP" : "Invest now"
                : "Create Mandate";
        }
        return "Invest now";
    };


    // API - resend otp
    const _generate2FaApi = () => {
        _generate2Fa("MF", selectedTab === 1 ? sipAmount : lumpsumAmount)
            .then((response) => {
                resetCountdown();
            }).catch((error) => {
                toast.dismiss();
                toast.error(error, {
                    type: "error",
                });
            });
    };

    // API - Create mandate
    const _createMandate = () => {
        setSubmitLoader(true);
        _checkMandate(true, paymentType.slug).then((response) => {
            if (response.status_code === 200) {
                let mandate_window = window.open(response.data.mandate_url, '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600');
                if (!mandate_window || typeof mandate_window.closed == 'undefined') {
                    toast.dismiss();
                    toast.error("Please enable pop-up permission");
                    return;
                };

                let timer = setInterval(function () {
                    if (mandate_window.closed) {
                        clearInterval(timer);
                        props.checkStatus()
                        if (props.status === false) {
                            setTimeout(() => {
                                setSubmitLoader(false);
                            }, 3000)
                        }
                    }
                }, 1000);
            } else {
                setSubmitLoader(false);
            }

        }).catch((error) => {
            setSubmitLoader(false);
        })
    }


    //API - confirm Invest
    const _confirmInvest = () => {
        setSubmitLoader(true)

        const url = props.fundType === 2 ? "/external/confirm-invest" : "/mf/confirm-invest";
        const request = props.fundType === 2 ? {
            "payment_type": paymentType.slug,
            "platform": "web",
            "sip": selectedTab === 1 ? {
                amount: sipAmount,
                date: selectedDate,
                get_first_installment: isFirstInstallment === 1 ? true : false
            } : null,
            "lumpsum": selectedTab === 2 ? {
                amount: lumpsumAmount
            } : null,
            "folio_number": folio !== null ? folio.value : undefined,
            "frequency": selectedTab === 1 ? frequencySelected : null,
            "id": props.id
        }
            :
            {
                "type": props.isReinvest ? "REINVEST" : null,
                "payment_type": paymentType.slug,
                "platform": "web",
                "sip": selectedTab === 1 ? {
                    amount: sipAmount,
                    date: selectedDate,
                    get_first_installment: isFirstInstallment === 1 ? true : false
                } : null,
                "lumpsum": selectedTab === 2 ? {
                    amount: lumpsumAmount
                } : null,
                "folio_number": folio !== null ? folio.value : undefined,
                "frequency": selectedTab === 1 ? frequencySelected : null,
                "mf_id": props.summary.mf_id
            }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setSubmitLoader(false);
                setOtpRequestData(request);
                setScreenNumber(2);
                resetCountdown();
                setOtp("");
            } else {
                setSubmitLoader(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
            }
        })
    }

    // 2nd screen investing 
    // API - fund invest
    const _mfInvest = async () => {
        setModalLoader(true);
        const url = props.fundType === 2 ? "/external/invest" : "/mf/invest";
        const request = {
            "type": props.isReinvest ? "REINVEST" : null,
            ...otpRequestData,
            otp: otp
        };

        try {
            const response = await APIService(true, url, request);
            if (response.status_code === 200) {
                if (response.data.payment_url) {
                    if (response.data.payment_provider === "RAZORPAY") {
                        _getRazorpay(response.data.rp_info.razorpay, response.data.payment_id, response.data.order_id);

                    } else {
                        let payment_url = window.open(response.data.payment_url, '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600');
                        if (!payment_url || typeof payment_url.closed == 'undefined') {
                            toast.dismiss();
                            toast.error("Please enable pop-up permission");
                            setTimeout(() => {
                                setModalLoader(false);
                            }, 1000);
                            return false;
                        }

                        return await new Promise((resolve) => {
                            let timer = setInterval(function () {
                                if (payment_url.closed) {
                                    clearInterval(timer);
                                    _getPaymentStatus(response.data.payment_id, response.data.order_id);
                                    setTimeout(() => {
                                        setModalLoader(false);
                                    }, 1000);
                                    resolve(true);
                                }
                            }, 1000);
                        });
                    }


                } else {
                    if (response.data.invested === true) {
                        setPaymentModalData({
                            status: response.data.invested,
                            image: SuccessImage,
                            title: selectedTab === 1 && isFirstInstallment === 2 ?
                                "SIP scheduled successfully" :
                                "Payment successful",
                            type: 1,
                            description: selectedTab === 1 && isFirstInstallment === 2 ?
                                "Your SIP order has been scheduled successfully. It will auto debit on next scheduled date." :
                                "Your payment has been successful and the order has been submitted to the RTA. The allocation will be reflected in T+2/3 days."
                        });

                    } else {
                        setPaymentModalData({
                            status: response.data.invested,
                            image: FailedImage,
                            title: response.data.message,
                            type: 0,
                            description: response.data.failed_reason ? response.data.failed_reason : "Your payment has been failed. Please try again."
                        });
                    }
                    setTimeout(() => {
                        setModalLoader(false);
                    }, 1000);
                    return true

                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
                setTimeout(() => {
                    setModalLoader(false);
                }, 1000);
                setOtp("");
                return false;
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setTimeout(() => {
                setModalLoader(false);
            }, 1000);
            return false;
        }
    }

    async function _getRazorpay(data, payment_id, order_id) {
        let paymentFailed = false;
        var options = {
            description: 'Payment for fund',
            image: process.env.REACT_APP_LOGO_URL,
            currency: 'INR',
            key: data.key,
            amount: data.amount,
            name: process.env.REACT_APP_COMPANY_NAME,
            order_id: data.order_id, // Replace this with an order_id created using Orders API.
            handler: (response) => {
                setScreenNumber(3);
                _getPaymentStatus(payment_id, order_id, true);
                setPaymentModalData({
                    order_id: order_id,
                    status: true,
                    image: SuccessImage,
                    title: selectedTab === 1 && isFirstInstallment === 2 ?
                        "SIP scheduled successfully" :
                        "Payment successful",
                    type: 1,
                    description: selectedTab === 1 && isFirstInstallment === 2 ?
                        "Your SIP order has been scheduled successfully. It will auto debit on next scheduled date." :
                        "Your payment has been successful and the order has been submitted to the RTA. The allocation will be reflected in T+2/3 days."
                });
                // Handle successful payment here
            },
            modal: {
                ondismiss: () => {
                    if (!paymentFailed) {
                        setScreenNumber(3);
                        _getPaymentStatus(payment_id, order_id, false);
                    }
                    // This function is triggered when the payment window is closed
                }
            },
            prefill: {
                email: data.email,
                contact: data.contact,
                name: PROFILE_DETAILS.name,
            },
            theme: { color: Color.rebecca_purple },

        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.on('payment.failed', function (response) {
            paymentFailed = true;
            setScreenNumber(3);
            setPaymentModalData({
                status: false,
                image: FailedImage,
                title: "Payment failed",
                type: 0,
                description: response.error.description
            });
        });
        razorpayInstance.open();

    };

    // API - payment status
    const _getPaymentStatus = (payment_id, order_id, is_razorpay = false) => {
        const url = "/payment/check-status";
        const request = {
            payment_id: payment_id
        }

        APIService(true, url, request).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                if (is_razorpay === false) {
                    if (response.data.status === true) {
                        setPaymentModalData({
                            order_id: order_id,
                            status: response.data.status,
                            image: SuccessImage,
                            title: selectedTab === 1 && isFirstInstallment === 2 ?
                                "SIP scheduled successfully" :
                                "Payment successful",
                            type: 1,
                            description: selectedTab === 1 && isFirstInstallment === 2 ?
                                "Your SIP order has been scheduled successfully. It will auto debit on next scheduled date." :
                                "Your payment has been successful and the order has been submitted to the RTA. The allocation will be reflected in T+2/3 days."
                        });
                    } else {
                        setPaymentModalData({
                            status: response.data.status,
                            image: FailedImage,
                            title: response.data.message,
                            type: 0,
                            description: response.data.failed_reason ? response.data.failed_reason : "Your payment has been failed. Please try again."
                        });
                    }
                }
                setTimeout(() => {
                    setModalLoader(false);
                }, 1000);
                return true

            } else {
                toast.error(response.message, {
                    type: "error",
                });
            }
        });
    }

    return (
        <Fragment>
            <div className={`modal fade ${style.e_payment_modal}`}
                id="fund-invest"
                tabIndex="-1"
                aria-labelledby="fund-invest"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>

                    <div className={`modal-content pb-4 ${style.e_content} `}>
                        <Icon icon="close-btn"
                            size={24}
                            color={Color.eerie_black}
                            id="close-modal"
                            className="cursor-pointer d-none"
                            data-bs-dismiss="modal" />
                        {
                            (screenNumber === 1 || screenNumber === 2) &&
                            <div className="border-bottom-1px border-ash-gray px-md-4 px-3">
                                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                                    {
                                        screenNumber === 1 &&
                                        <h5 className='e-font-16 mb-0 color-eerie-black e-montserrat-semi-bold e-line-height-24'>
                                            {
                                                location.pathname === "/explore/detail" ?
                                                    "Invest now"
                                                    :
                                                    "Invest More"
                                            }
                                        </h5>
                                    }
                                    {
                                        screenNumber === 2 &&
                                        <h5 className='e-font-16 mb-0 color-eerie-black e-montserrat-semi-bold e-line-height-24'>
                                            <Icon icon="Arrow-Right"
                                                size={22}
                                                className="e-transform-left-arrow cursor-pointer me-2"
                                                onClick={() => setScreenNumber(1)} />  Enter OTP
                                        </h5>
                                    }
                                    <Icon icon="close-btn"
                                        size={24}
                                        color={Color.eerie_black}
                                        id="close-fund"
                                        className="cursor-pointer"
                                        data-bs-dismiss="modal" />
                                </div>
                            </div>
                        }
                        <div className={style.e_height}>
                            {
                                screenNumber === 1 ?
                                    <Fragment>
                                        <div className="box-shadow-black p-3 mx-md-4 mx-3 gap-8px border-radius-16px mt-3 d-flex align-items-center">
                                            <img src={props.summary.image}
                                                alt="goal"
                                                width={38}
                                                height={38}
                                                className="box-shadow-black border-radius-12px" />
                                            <span className="e-montserrat-semi-bold e-font-14 e-line-height-20 color-eerie-black mb-0">{props.summary.name}</span>
                                        </div>

                                        {/* avaialbe investment types */}
                                        <div className="px-sm-4 px-3 ">
                                            <div className="border-bottom-1px border-chinese-white mt-2">
                                                <CustomTabBar data={props.summary.sip_enabled === false && props.summary.lumpsum_enabled === true ? LUMPSUM_DATA :
                                                    props.summary.sip_enabled === true && props.summary.lumpsum_enabled === false ? SIP_DATA : TAB_DATA}
                                                    selectedTab={selectedTab}
                                                    onSelectTab={_handleTabChange} />
                                            </div>
                                        </div>
                                        {/* investment amount input */}
                                        <div className="mt-3 mx-md-4 mx-3">
                                            <div ref={amountRef}>
                                                {
                                                    selectedTab === 1 ?
                                                        <CustomAmountInput value={sipAmount}
                                                            error={sipAmountError}
                                                            key={"SipAmount"}
                                                            label="Investment Amount"
                                                            placeholder="50,000"
                                                            postfix="*"
                                                            handleChange={_handleAmount} />
                                                        :
                                                        <CustomAmountInput value={lumpsumAmount}
                                                            error={lumpsumAmountError}
                                                            key={"LumpsumAmount"}
                                                            label="Lumpsum Amount"
                                                            placeholder="50,000"
                                                            postfix="*"
                                                            handleChange={_handleLumpsum} />
                                                }
                                            </div>

                                            <div className="d-flex flex-wrap gap-12px mt-4 pt-1 mb-3">
                                                {
                                                    AMOUNT_CHIP.map((item, key) =>
                                                        <span className="px-sm-3 px-2 py-2 border-bright-gray border-1px e-montserrat-semi-bold e-font-14 e-line-height-20 color-eerie-black border-radius-20px cursor-pointer user-select-none"
                                                            key={key}
                                                            onClick={() => _handleChipClick(item)}>{item.label}</span>
                                                    )
                                                }
                                            </div>
                                            {folioOptions.length > 1 && <CustomDropdown label="Folio"
                                                postfix="*"
                                                options={folioOptions}
                                                value={folio}
                                                placeholder="Select Folio"
                                                className="mt-2 pb-1 mb-3"
                                                isSingleValue={true}
                                                prefix={folio !== null && folio.value === null ? "Create New Folio" : ""}
                                                error={folioError}
                                                message="No folios found"
                                                onSelectChange={_handleFolio} />}
                                            {selectedTab === 1 &&
                                                <Fragment>
                                                    {frequencyOptions.length > 0 && <div className="mb-3">
                                                        <p className={`e-montserrat-medium color-dark-charcoal e-font-14 e-line-height-18 cursor-text mb-0 bg-transparent`}>
                                                            Select Frequency
                                                        </p>

                                                        <RadioGroup data={frequencyOptions}
                                                            selected={frequencySelected}
                                                            handleSelect={_handleFrequency} />

                                                    </div>}

                                                </Fragment>
                                            }
                                        </div>

                                        {/* SIP date input */}
                                        {
                                            selectedTab === 1 && frequencySelected !== "daily" ?
                                                (frequencySelected === "day_in_a_week" || frequencySelected === "day_in_a_fortnight") ?
                                                    <CustomDropdown label="Select day"
                                                        postfix="*"
                                                        options={WEEKLY_OPTIONS}
                                                        value={daySelected}
                                                        error={daySelectedError}
                                                        placeholder="Select day"
                                                        className="pb-2 mx-md-4 mx-3 mb-3"
                                                        isSingleValue={true}
                                                        hideValue
                                                        prefix={frequencySelected === "day_in_a_fortnight" ? `Every alternate ${daySelected !== null && daySelected.label}` : `Every ${daySelected !== null && daySelected.label}`}
                                                        onSelectChange={_handleWeeklyDate} />
                                                    :
                                                    <Fragment>
                                                        <p className="e-font-14 e-line-height-24 e-montserrat-medium color-eerie-black mb-2 mx-md-4 mx-3">
                                                            Select SIP date
                                                        </p>

                                                        {/* SIP component */}
                                                        <div className="padding-14px-tb px-3 bg-white box-shadow-charleston border-1px border-light-grayish-blue d-flex justify-content-between align-items-center border-radius-12px cursor-pointer mx-md-4 mx-3 mb-3"
                                                            onClick={() => _handleCloseModal(true)}>
                                                            <span className="color-rebecca-purple e-font-14 e-montserrat-semi-bold e-line-height-18">{selectedDateString} {frequencySelected === "monthly" && "of every month"}</span>
                                                            <Icon icon="dob"
                                                                size={24} />
                                                        </div>
                                                    </Fragment>
                                                :
                                                null
                                        }

                                        {/* show first instalment selection if investment tyupe is SIP */}
                                        {
                                            selectedTab === 1 &&
                                            <div className="mx-md-4 mx-3">
                                                <p className={`e-montserrat-medium color-dark-charcoal e-font-14 e-line-height-18 cursor-text mb-0 bg-transparent`}>
                                                    Pay first installment now?
                                                </p>

                                                <RadioGroup data={FIRST_INSTALLMENT}
                                                    selected={isFirstInstallment}
                                                    handleSelect={_handleFirstInstallment} />

                                                {
                                                    isFirstInstallment === 1 ?
                                                        <div className="d-flex align-items-center gap-8px e-bg-ivory-bridge p-2 pe-4 border-radius-12px mb-4 mt-2">
                                                            <Icon icon="info-circle-yellow"
                                                                size={18}
                                                                color="#C75802" />
                                                            <p className="e-montserrat-medium e-font-12 e-line-height-18 color-dark-golden mb-0">Your first SIP will be deducted immediately.</p>
                                                        </div>
                                                        :
                                                        isFirstInstallment === 2 ?
                                                            <div className="d-flex align-items-center gap-8px e-bg-ivory-bridge p-2 pe-4 border-radius-12px mb-4 mt-2">
                                                                <Icon icon="info-circle-yellow"
                                                                    size={18}
                                                                    color="#C75802" />
                                                                <p className="e-montserrat-medium e-font-12 e-line-height-18 color-dark-golden mb-0">Your first SIP shall start from the selected date.</p>
                                                            </div>
                                                            :
                                                            null
                                                }
                                            </div>
                                        }

                                        {
                                            props.summary.mandate_status === false ?
                                                <Fragment>
                                                    <h5 className='e-font-14  color-eerie-black e-montserrat-semi-bold e-line-height-22 mx-md-4 mx-3 mb-0'>
                                                        {selectedTab === 1 ? "Mandate Method" : "Payment Method"}
                                                    </h5>
                                                    {
                                                        props.summary.payment_types.map((item, index) => {
                                                            return (
                                                                <div key={index}
                                                                    className={`py-2 mx-md-4 mx-3 padding-12px-lr d-flex align-items-center justify-content-between border-1px cursor-pointer mt-3 border-radius-12px  ${item.id === paymentType.id ? "border-purple e-bg-light-lavender" : "border-bright-gray"}`} onClick={() => _handlePayment(item)}>
                                                                    <div className="d-flex align-items-center gap-8px">
                                                                        <img src={item.image} alt={"Basket"}
                                                                            draggable={false}
                                                                            width={46}
                                                                            height={32} />
                                                                        <span className="e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 color-eerie-black">
                                                                            {item.label}
                                                                        </span>
                                                                    </div>
                                                                    <Icon icon={item.id === paymentType.id ? 'radio-checked1' : 'radio-unchecked'}
                                                                        size={24} />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Fragment>
                                                :
                                                selectedTab === 1 && isFirstInstallment === 1 ?
                                                    <Fragment>
                                                        <h5 className='e-font-14  color-eerie-black e-montserrat-semi-bold e-line-height-22 mx-md-4 mx-3 mb-0'>
                                                            Payment Method
                                                        </h5>
                                                        {
                                                            props.summary.payment_types.map((item, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        className={`py-2 mx-md-4 mx-3 padding-12px-lr d-flex align-items-center justify-content-between border-1px cursor-pointer mt-3 border-radius-12px  ${item.id === paymentType.id ? "border-purple e-bg-light-lavender" : "border-bright-gray"}`} onClick={() => _handlePayment(item)}>
                                                                        <div className="d-flex align-items-center gap-8px">
                                                                            <img src={item.image} alt={"Basket"}
                                                                                draggable={false}
                                                                                width={46}
                                                                                height={32} />
                                                                            <span className="e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 color-eerie-black">
                                                                                {item.label}
                                                                            </span>
                                                                        </div>
                                                                        <Icon icon={item.id === paymentType.id ? 'radio-checked1' : 'radio-unchecked'}
                                                                            size={24} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </Fragment>
                                                    :
                                                    selectedTab === 2 ?
                                                        <Fragment>
                                                            <h5 className='e-font-14  color-eerie-black e-montserrat-semi-bold e-line-height-22 mx-md-4 mx-3 mb-0'>
                                                                Payment Method
                                                            </h5>
                                                            {
                                                                props.summary.payment_types.map((item, index) => {
                                                                    return (
                                                                        <div key={index}
                                                                            className={`py-2 mx-md-4 mx-3 padding-12px-lr d-flex align-items-center justify-content-between border-1px cursor-pointer mt-3 border-radius-12px  ${item.id === paymentType.id ? "border-purple e-bg-light-lavender" : "border-bright-gray"}`} onClick={() => _handlePayment(item)}>
                                                                            <div className="d-flex align-items-center gap-8px">
                                                                                <img src={item.image} alt={"Basket"}
                                                                                    draggable={false}
                                                                                    width={46}
                                                                                    height={32} />
                                                                                <span className="e-montserrat-semi-bold e-font-14 e-line-height-20 mb-0 color-eerie-black">
                                                                                    {item.label}
                                                                                </span>
                                                                            </div>
                                                                            <Icon icon={item.id === paymentType.id ? 'radio-checked1' : 'radio-unchecked'}
                                                                                size={24} />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Fragment>
                                                        :
                                                        null
                                        }

                                        {
                                            props.summary.mandate_status === false && selectedTab === 1 &&
                                            <div className="d-flex align-items-start padding-12px-all  e-bg-light-blue border-radius-12px mt-4 color-ocean-blue e-font-12 e-line-height-20 gap-4px e-montserrat-medium mx-md-4 mx-3">
                                                <span>
                                                    <Icon icon="info-circle"
                                                        size={16} />
                                                </span>
                                                The mandate is for the automatic debit of your monthly SIP. It's important to know that the mandate allows a maximum value of {paymentType.slug === "UPI" ? props.summary.mandate_limit.UPI : props.summary.mandate_limit.E_MANDATE}. However, the auto-debit will occur at the exact SIP order value. There will be no additional charges for the mandate's auto-debit feature.
                                            </div>
                                        }
                                        {props.summary.mandate_status === true && selectedTab === 1 && <div className="mx-md-4 mx-3 mb-3"
                                            ref={termsRef}>
                                            <ConsentCard acceptedTerms={acceptedTerms}
                                                error={termsError}
                                                setAcceptedTerms={() => {
                                                    setAcceptedTerms(!acceptedTerms);
                                                    setTermsError(false);
                                                }} />
                                        </div>}

                                        {selectedTab === 2 && <div className="mx-md-4 mx-3 mb-3"
                                            ref={termsRef}>
                                            <ConsentCard acceptedTerms={acceptedTerms}
                                                error={termsError}
                                                setAcceptedTerms={() => {
                                                    setAcceptedTerms(!acceptedTerms);
                                                    setTermsError(false);
                                                }} />
                                        </div>}

                                        {
                                            props.showInfo && props.summary.mandate_status === true && selectedTab === 1 ?
                                                <div className="d-flex align-items-start padding-12px-all  e-bg-light-blue border-radius-12px mx-md-4 mx-3 color-ocean-blue e-font-12 e-line-height-18 gap-4px e-montserrat-medium">
                                                    <span>
                                                        <Icon icon="info-circle"
                                                            size={16} />
                                                    </span>
                                                    Your investments will be allocated to existing folio’s of previous investments (if any) of respective fund houses.
                                                </div>
                                                :
                                                props.showInfo && selectedTab === 2 ?
                                                    <div className="d-flex align-items-start padding-12px-all  e-bg-light-blue border-radius-12px mx-md-4 mx-3 color-ocean-blue e-font-12 e-line-height-18 gap-4px e-montserrat-medium">
                                                        <span>
                                                            <Icon icon="info-circle"
                                                                size={16} />
                                                        </span>
                                                        Your investments will be allocated to existing folio’s of previous investments (if any) of respective fund houses.
                                                    </div>
                                                    :
                                                    null
                                        }
                                    </Fragment>
                                    :
                                    screenNumber === 2 ?
                                        <div className="px-md-4 px-3 padding-14px-top">
                                            <p className="e-font-14 mb-2 color-eerie-black e-montserrat-regular e-line-height-24">
                                                An OTP has been sent to your PAN linked mobile
                                                number.
                                            </p>
                                            <h6 className="e-font-16 mb-3 color-eerie-black e-montserrat-semi-bold e-line-height-24">{MASKED_NUMBER}</h6>
                                            <CustomPINInput id="otp"
                                                autoFocus={true}
                                                pinString={otp}
                                                error={otpError}
                                                postfix="*"
                                                label="Enter OTP"
                                                onSubmit={_submitOTP}
                                                handleChange={_handleOTP} />
                                            <p className="color-charcoal-blue e-montserrat-medium e-font-14 e-line-height-20 mt-4">Didn’t get OTP? <span className={`no-decoration color-rebecca-purple e-link 
                                            ${seconds === 0 ?
                                                    'cursor-pointer'
                                                    : 'disabled'}`}
                                                onClick={_handleResend}>
                                                {seconds === 0 ?
                                                    'Resend OTP'
                                                    : `Resend OTP in ${seconds < 10 ? `0${seconds}` : seconds}s`}
                                            </span>
                                            </p>

                                        </div>
                                        :
                                        <div className="text-center px-md-4 px-3">
                                            <img src={paymentModalData.image}
                                                alt={paymentModalData.title}
                                                draggable={false}
                                                width={144}
                                                height={144}
                                                className="mx-auto" />
                                            <h5 className="e-font-16 e-line-height-24 e-montserrat-semi-bold color-eerie-black mb-0">
                                                {paymentModalData.title}
                                            </h5>

                                            <p className="e-montserrat-medium e-font-16 e-line-height-28 color-charcoal-gray mt-2 mb-0 ">
                                                {paymentModalData.description} {paymentModalData.type === 1 && isFirstInstallment === 1 && <LinkButton label="View TAT"
                                                    className="e-font-14 d-inline-block"
                                                    onPress={() => window.open(`${window.location.origin}/view-tat`, "_blank")} />}
                                            </p>
                                        </div>
                            }
                        </div>
                        {
                            screenNumber === 1 ?
                                <div className="row d-flex justify-content-center">
                                    <div className="col-6 ">
                                        <PrimaryButton label={_investLabel()}
                                            className="w-100 padding-10px-tb mt-4"
                                            showLoader={folioOptions.length === 0 ? false : submitLoader}
                                            disabled={props.summary.mandate_status === false && selectedTab === 1 ? false : folioOptions.length === 0 ? true : submitLoader}
                                            onPress={_handleInvest} />
                                    </div>
                                </div> :
                                screenNumber === 2 ?
                                    <div className="px-md-4 px-3 mt-4">
                                        <div className="row">
                                            <div className="col-6">
                                                <SecondaryButton label="Cancel"
                                                    className="padding-12px-tb w-100 e-bg-magnolia"
                                                    cancel="modal" />
                                            </div>
                                            <div className="col-6">
                                                <PrimaryButton label={_otpLabel()}
                                                    className="padding-12px-tb  w-100"
                                                    disabled={modalLoader}
                                                    onPress={_submitOTP} />
                                            </div>
                                        </div>

                                    </div> :
                                    <div className="row px-md-4 px-3 d-flex align-items-center justify-content-center mt-4">

                                        <div className="col-6">
                                            <SecondaryButton label={selectedTab === 1 && isFirstInstallment === 2 ? "View SIP" : "View Order"}
                                                cancel="modal"
                                                className="padding-12px-tb w-100 e-bg-magnolia"
                                                onPress={_handleScreen3SecondaryButton} />
                                        </div>


                                        <div className="col-6">
                                            <PrimaryButton label={paymentModalData.type === 1 ? "Portfolio" : "Go back"}
                                                className=" padding-12px-tb w-100"
                                                cancel="modal"
                                                onPress={_handleScreen3PrimaryButton} />
                                        </div>

                                    </div>


                        }

                    </div>

                </div>
                {
                    (toggleDateModal === true) &&
                    <Fragment>
                        <SIPDateModal apiDates={props.frequencyData[`${frequencySelected}`].dates !== null && frequencySelected !== null ? props.frequencyData[`${frequencySelected}`].dates.map((item) => item.toString()) : []}
                            selectedSIPDate={selectedDate}
                            handleSelect={_handleSelectDate}
                            backdrop={!toggleDateModal}
                            handleCloseDateModal={() => _handleCloseModal(false)} />
                        <div className="position-fixed bg-black opacity-1 w-100 h-100 z-index-4 top-0 start-0">
                        </div>
                    </Fragment>
                }
            </div>
        </Fragment>
    )
})

FundInvestModal.defaultProps = {
    selected: 1,
    fundType: 1,
    handleTabChange: () => { },
    amount: "",
    lumpsumAmount: "",
    frequencies: [],
    folioData: [],
}

export default FundInvestModal;
